import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {RiListCheck3} from "react-icons/ri";
import Select from "react-select";
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import {CgPlayListCheck} from "react-icons/cg";




function BOrders() {

    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);
    const [status, setStatus] = React.useState( null);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState( null);
    const [dateTo, setDateTo] = React.useState( null);
    const [pagesCount, setPagesCount] = React.useState( []);
    const [page, setPage] = React.useState( 1);
    const [total, setTotal] = React.useState( 0);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const  toMonth = dateTo?.toDate?.().getMonth() -(-1);
        let params = {
            count: 50,
            page: page,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'Sales',
            status_id:  status,
            sb : 1,
            vendor_id: selectedOptions?.value,
            date_from: typeof dateFrom?.toDate?.().getFullYear() !== "undefined" ? dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' +dateFrom?.toDate?.().getDate() + ' 00:00' : '',
            date_to: typeof dateTo?.toDate?.().getFullYear() !== "undefined" ? dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59': '',
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
                setTotal(response.meta.total)
                setPagesCount( Array.from({length: response.meta.last_page}, (_, index) => index + 1))
                setIsLoaded(true)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });


        if(!selectOptions.length) {
            let params = {
                count: 200,
                page: 1,
                list: 1,
                orderBy: 'created_at',
                orderType: 'desc',
                processFor: 'Sales',


            }
        API.getVendors(params)
            .then((response) => {

                const vendors = response.data;
                let options = [];
                for (let data in vendors) {

                    options.push({
                        value: vendors[data].id,
                        label: vendors[data].title + " - " + vendors[data].city,
                    })
                }
                setSelectOptions(options)


            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        }
    }, [status, selectedOptions, dateFrom, dateTo, selectOptions , page]);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="sborders"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
همه                        سفارش ها
                    </h1>
                    {/*   <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item">Pages</li>
                            <li className="breadcrumb-item active">Blank</li>
                        </ol>
                    </nav>*/}
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4 table-responsive">
                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">
                                        <div className="col-md-3 pt-2">
                                            <div className=" text-small-2">
                                                <select className="form-select  " id="floatingSelect" aria-label="Floating label select "
                                                        onChange={ (val) => {

                                                            setPage(1)
                                                            setStatus(
                                                                val.target.value === 'x' ? null : val.target.value
                                                            )
                                                        }}
                                                >
                                                    <option selected value='x'>
                                                        همه وضعیت ها
                                                    </option>
                                                    <option  value='1'>
                                                        ثبت اولیه
                                                    </option>

                                                    <option  value='13'>
                                                        تایید شده
                                                    </option>
                                                    <option  value='17'>
                                                        انبار - بارگیری
                                                    </option>
                                                    <option  value='7'>
                                                        آماده ارسال
                                                    </option>
                                                    <option  value='14'>
                                                        ارسال شده
                                                    </option>
                                                    <option  value='17'>
                                                     انبار
                                                    </option>
                                                    <option  value='20'>
                                                       کنترل کیفیت
                                                    </option>
                                                    <option  value='16'>
                                                        کنسل شده
                                                    </option>


                                                </select>

                                            </div>
                                        </div>
                                        <div className="col-md-3  pt-2">
                                            <Select
                                                options={selectOptions}
                                                placeholder="فیلتر بر اساس نماینده"
                                                value={selectedOptions}

                                                isSearchable={true}
                                                onChange={

                                                    (event) => {
                                                        setSelectedOptions(event)
                                                        setPage(1)
                                                    }
                                                }
                                            />
                                        </div>
                                        <div className="col-md-3  text-start pt-2">
                                        <span className='float-end mt-2'>
                                            از تاریخ:
                                        </span>
                                            <DatePicker

                                                onChange={ (val) => {
                                                    setDateFrom(val)
                                                    setPage(1)
                                                } }
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition= "bottom-right"
                                                className="rmdp-mobile"
                                                //value={this.state.date_from}

                                            />

                                        </div>
                                        <div className="col-md-3 pt-2 text-start">
                                        <span className='float-end mt-2'>
                                            تا تاریخ:
                                        </span>
                                            <DatePicker
                                                //value={this.state.date_to}
                                                onChange={ (val) => {
                                                    setDateTo(val)
                                                    setPage(1)
                                                } }
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition= "bottom-right"
                                                className="rmdp-mobile"

                                            />
                                        </div>


                                    </div>


                                    <div className="row mb-3 pb-2 border-bottom ">
                                        <div className="col-6 text-end fw-bold text-small-2 pe-3 text-primary opacity-75">
                                            <CgPlayListCheck className='ms-2 text-big-4' />
                                            تعداد کل سفارش ها:
                                            &nbsp;
                                            {total}
                                        </div>
                                        <div className="col-6 text-start text-small-3">
                                            صفحه:
                                            <select  className='bg-secondary-subtle border-0 px-2 mx-2'
                                                     value={page}
                                            onChange={(val) =>{
                                                setPage(val.target.value)
                                            }}
                                            >

                                                {
                                                    pagesCount.map(pc => {
                                                        return (
                                                            <option value={pc}>{pc}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table ">
                                        <thead >
                                        <tr className='text-small-2 text-muted'>
                                            <th scope="col" className='bg-success-subtle rounded-end-3'># </th>
                                            <th scope="col" className='bg-success-subtle'>نماینده</th>
                                            <th scope="col" className='bg-success-subtle'>تعداد باتری</th>
                                            <th scope="col" className='bg-success-subtle'>کد سفارش</th>
                                            <th scope="col" className='bg-success-subtle'>تاریخ ثبت</th>
                                            <th scope="col" className='bg-success-subtle rounded-start-3'>وضعیت</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            orders.map (order => {
                                                return (
                                                    <tr  key={order.id}
                                                         role='button'
                                                         onClick={() => {
                                                             if (order.last_status?.id === 1) {
                                                                 navigate(`/sb-orders/${order.id}`)
                                                             } else {
                                                                 navigate(`/orders/${order.id}`)
                                                             }
                                                         }
                                                    }
                                                    >
                                                        <th scope="row">
                                                            {order.factor_number}
                                                        </th>
                                                        <td>
                                                            {order.vendor?.title}
                                                            &nbsp;
                                                            <span
                                                                className='text-small-2 text-muted'>({order.vendor?.city})</span>
                                                            {
                                                                order.vendor.is_tropical ?
                                                                    <span className='badge text-bg-warning mx-2 p-2'> گرمسیری</span>
                                                                    : ""
                                                            }
                                                        </td>
                                                        <td>
                                                            {order.battery_qty}
                                                        </td>
                                                        <td>
                                                            {order.tracking_code}
                                                        </td>
                                                        <td className='text-small-2' >
                                                            {order.date}
                                                        </td>



                                                        <td
                                                            style={{color:order.last_status?.color}}
                                                            className='text-small-2'
                                                        >
                                                            {order.last_status?.title}
                                                        </td>
                                                    </tr>
                                                )} )
                                        }
                                        </tbody>
                                    </table>


                                </div>
                            </div>

                        </div>



                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default BOrders;